import React, { useEffect, useState, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import { Header } from "../components/Sidebar";
import api from "../lib/api";
import { formatGs, ROLE_LABELS } from "../lib/format";
import { Bike } from "lucide-react";

export default function Repartidores() {
  const { setMobileOpen } = useOutletContext();
  const [users, setUsers] = useState([]);
  const [rend, setRend] = useState([]);
  const load = useCallback(() => {
    api.get("/users").then(({ data }) => setUsers(data.filter((u) => ["repartidor", "comisionista"].includes(u.role)))).catch(() => {});
    api.get("/rendiciones").then(({ data }) => setRend(data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const rendFor = (id) => rend.find((r) => r.cobrador_id === id);

  return (
    <>
      <Header title="Repartidores" subtitle="Equipo de reparto y comisionistas" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {users.map((u) => {
            const r = rendFor(u.id);
            return (
              <div key={u.id} className="bg-white rounded-xl border border-[#E2E8F0] p-5 shadow-sm" data-testid={`repartidor-card-${u.id}`}>
                <div className="flex items-center gap-3">
                  <div className="h-11 w-11 rounded-xl bg-blue-50 border border-blue-100 flex items-center justify-center"><Bike className="h-5 w-5 text-[#3B82F6]" /></div>
                  <div>
                    <div className="font-bold text-[#0A1F44]">{u.name}</div>
                    <div className="text-xs text-[#64748B]">{ROLE_LABELS[u.role]}{u.sucursal ? ` · ${u.sucursal}` : ""}</div>
                  </div>
                </div>
                <div className="mt-4 flex items-center justify-between rounded-lg bg-slate-50 border border-slate-200 px-3 py-2">
                  <span className="text-xs text-[#64748B]">A rendir</span>
                  <span className="text-sm font-bold text-[#0A1F44]">{formatGs(r?.total || 0)}</span>
                </div>
              </div>
            );
          })}
          {users.length === 0 && <div className="col-span-full text-center py-12 text-[#64748B] bg-white rounded-xl border border-[#E2E8F0]">No hay repartidores. Creálos en Usuarios y Roles.</div>}
        </div>
      </main>
    </>
  );
}
